import { AccommodationActivity, AccommodationActivityClass } from "@/lib/builder/models/activity.model";

export const createCheckInOutActivities = (activityData: AccommodationActivityClass): AccommodationActivityClass[] => {
    const checkInDate = (activityData as any).check_in_date || activityData.start_date || (activityData as any).from_date;
    const checkOutDate = (activityData as any).check_out_date || activityData.end_date || (activityData as any).to_date;

    // Usa l'ID già generato dalla modale, altrimenti genera un UUID
    const generatedId = activityData.id || crypto.randomUUID();

    // Create check-in activity
    return [
        new AccommodationActivityClass({
            ...activityData,
            type: 'accommodation',
            inOrOutActivity: 'in',
            start_date: checkInDate,
            end_date: checkOutDate,
            id: generatedId,
            date: activityData.start_date
        }),
        new AccommodationActivityClass({
            ...activityData,
            type: 'accommodation',
            inOrOutActivity: 'out',
            start_date: checkOutDate,
            end_date: checkOutDate,
            id: generatedId + '-out',
            date: activityData.end_date
        })
    ];
};